module.exports = __webpack_public_path__ + "static/img/lodash.69531267.png";